import {
  TranscriptorConsultation,
  UPLOAD_NOT_COMPLETED_ERROR,
} from '../config';

export const isUploadNotCompleted = (
  consultation?: Partial<
    Pick<TranscriptorConsultation, 'status' | 'error'>
  > | null,
): boolean =>
  consultation?.status === 'failed' &&
  consultation.error?.toLowerCase() === UPLOAD_NOT_COMPLETED_ERROR;
